import React from "react";
import Settings from "./Settings";

/**
 * Wrapper that lets us update Settings page layout/styling
 * without touching `src/pages/Settings.jsx` directly.
 */
export default function SettingsUI(props) {
  return (
    <Settings {...props} />
  );
}

